import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import CompanyOwnerRegisterPage from './CompanyOwnerRegisterPage';
import RegisterPage from './RegisterPage';
import RoleChooser from '../features/register/RoleChooser';
import {
  getCompanyOwnerCompany,
  getCompanyOwnerAuthUser,
  saveCompanyOwnerClaimToken,
} from '../services/storage/companyOwnerFlow';
import { getCompanyOwnerNextRoute, isCompanyOwnerUser } from '../utils/companyOwner';

const ROLES = ['customer', 'driver', 'company'];

const RegisterEntryPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const role = searchParams.get('role');

  /* No role yet — ask before dropping anyone into a form. A ?role= link (from
     the chooser, the footer, or a campaign) skips straight to that flow. */
  if (!role || !ROLES.includes(role)) {
    return <RoleChooser />;
  }

  if (role === 'company') {
    const claimToken = searchParams.get('claimToken')?.trim();
    const companyOwnerUser = getCompanyOwnerAuthUser();
    if (isCompanyOwnerUser(companyOwnerUser)) {
      if (claimToken) {
        saveCompanyOwnerClaimToken(claimToken);
      }
      return <Navigate replace to={getCompanyOwnerNextRoute(getCompanyOwnerCompany())} />;
    }

    return <CompanyOwnerRegisterPage />;
  }

  return <RegisterPage />;
};

export default RegisterEntryPage;
